<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <warehouse-form
          @submit="submit"
          :init-warehouse="{}"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import WarehouseForm from './warehouse-form'

export default {
  components: { WarehouseForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (supplier) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('warehouses', supplier).then(({ data }) => {
        this.$notify({
          message: 'Lager erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/warehouses')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  }
}
</script>

<style>
</style>
